import { NavLink } from "react-router-dom";
import { getAuth, isAdmin } from "../utils/auth";

export default function Navigation() {
  const user = getAuth();

  const navItems = [
    { path: "/admin", name: "Home", active: true },
    {
      path: "/admin/createlogin",
      name: "Create Login",
      active: true && isAdmin(user.roleId),
    },
    { path: "/admin/changepassword", name: "Change Password", active: true },
    { path: "/admin/wedgits", name: "Home Page Activity", active: false },
    { path: "/admin/hall", name: "Hall Data", active: true },
    { path: "/admin/goals", name: "Goals Data", active: true },
    { path: "/admin/upakram", name: "Upakram Data", active: true },
    { path: "/admin/computers", name: "Computer Data", active: true },
    { path: "/admin/photos", name: "Photo Gallery", active: true },
    { path: "/admin/founders", name: "Mandal Founders", active: true },
    {
      path: "/admin/vishwasthamandal",
      name: "Vishwastha Mandal",
      active: true,
    },
    { path: "/admin/vidyamanmandal", name: "Vidyaman Mandal", active: true },
    { path: "/admin/ahaval", name: "Ahaval Activity", active: true },
    { path: "/admin/sitesetting", name: "Profile Activity", active: true },
    { path: "/admin/searchmember", name: "Member/ SMS", active: true },
  ];
  return (
    <div className="div-topmenu">
      <div className="div-menu-admin">
        <ul>
          {navItems.map(
            (item, index) =>
              item.active && (
                <NavLink to={item.path} key={index + 1}>
                  <li>{item.name}</li>
                </NavLink>
              )
          )}
        </ul>
      </div>
    </div>
  );
}
